import {DLMLabellingListToolbar} from './DLMLabellingListToolbar'
import {DLMLabellingListSearchComponent} from './DLMLabellingListSearchComponent'

const DLMLabellingListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
        <DLMLabellingListSearchComponent />        
        <div className='card-toolbar'>        
            <DLMLabellingListToolbar />        
        </div>      
    </div>
  )
}

export {DLMLabellingListHeader}
